import { useIntl } from 'react-intl';

import { ReadMore } from '../../../../../../../design-system/components/read-more/ReadMore';
import { Typography } from '../../../../../../../design-system/components/typography/Typography';
import { HtmlContent } from '../../../../../../../domains/Layout/HtmlContent/HtmlContent';
import { DestinationContents } from '../../../../../../../resources/destinationContents/domain/types/destinationContents';

import style from './WhereToGoSectionDescription.module.css';

type Props = {
    title: string;
    content: DestinationContents['whatToDoContent'];
};

export function WhereToGoSectionDescription({ title, content }: Props) {
    const { formatMessage } = useIntl();

    return (
        <div className={style.descriptionWrapper}>
            <Typography className={style.title} as="h2" scale="secondary-m-bold">
                {title}
            </Typography>

            <ReadMore
                lineClamp={15}
                readMore={formatMessage({ id: 'global.cta.seeMore' })}
                readLess={formatMessage({ id: 'global.cta.seeLess' })}
            >
                <HtmlContent htmlContent={content} />
            </ReadMore>
        </div>
    );
}
